/**
 * Button Styles
 * 
 * Styled-components definition for interactive buttons with customizable appearance.
 * Handles color variants, hover states, and consistent typography.
 * 
 * Interactions:
 * - Uses TypeScript interface for prop-based styling customization
 * - Integrates with global color palette and brand colors
 * - Provides smooth transitions for hover and focus states
 * - Implements consistent border radius and padding standards
 * - Supports box shadow toggling for different button variants
 */

import styled from "styled-components";

interface StyledButtonProps {
  color?: string;
  textColor?: string;
  boxShadow?: boolean;
}

export const StyledButton = styled("button")<StyledButtonProps>`
  background: ${(p) => p.color || "rgba(239, 196, 103, 1)"};
  color: ${(p) => p.textColor || "rgba(30, 77, 118, 1)"};
  font-family: 'Merriweather', serif;
  font-size: 1rem;
  font-weight: 600;
  width: auto;
  border: 1px solid rgba(239, 196, 103, 1);
  border-radius: 0px;
  padding: 13px 30px;
  cursor: pointer;
  margin-top: 0.625rem;
  white-space: nowrap;
  transition: all 0.3s ease-in-out;
  box-shadow: ${(p) => (p.boxShadow === false ? "none" : "0 16px 30px rgb(23 31 114 / 20%)")};

  &:hover,
  &:active,
  &:focus {
    color: ${(p) => p.textColor || "#fff"};
    border: 1px solid #ae801cff
    background-color: #ae801cff
  }
`;
